<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yM9w49/tc-custom/9781466829992.jpg?1737768259588" alt="This image is the cover for the book Curzon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Curzon
      </h1>
      <p class="bookDescription body article font2">
        <p>“<b>[An] elegant biography” of the British statesman’s accomplished and controversial life and career: “A fast-moving, entertaining and finely written story” (Simon Schama, <i>The New Yorker</i>).</b><br/><br/>George Nathaniel Curzon’s controversial life in public service stretched from the high noon of his country’s empire to the traumatized years following World War I. As Viceroy of India under Queen Victoria and Foreign Secretary under King George V, the obsessive Lord Curzon left his unmistakable mark on the era. David Gilmour’s award-winning book—with a new foreword by the author—is a brilliant assessment of Curzon’s character and achievements, offering a richly dramatic account of the infamous long vendettas, the turbulent friendships, and the passionate, risky love affairs that complicated and enriched his life.<br/><br/>Born into the ruling class of what was then the world’s greatest power, Curzon was a fervent believer in British imperialism who spent his life proving he was fit for the task. Often seen as arrogant and tempestuous, he was loathed as much as he was adored, his work disparaged as much as it was admired. In Gilmour’s well-rounded appraisal, Curzon emerges as a complex, tragic figure, a gifted leader who saw his imperial world overshadowed at the dawn of democracy.<br/><br/><b>“A Superb New Biography . . . A Tragic Story, Brilliantly Told.” —Andrew Roberts, <i>Literary Review</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Gilmour
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65896262